import { publicApiClient } from '@/lib/api/client';
import type { EventScheduleResponse } from '@/features/booking/types/eventBookingCategoryTypes';

// API response wrapper for event schedule
interface EventScheduleApiResponse {
  data: {
    "event-schedule": EventScheduleResponse;
  };
}

/**
 * Service for fetching event booking categories
 */
export const eventBookingCategoryService = {
  /**
   * Fetches event schedule details including booking categories
   * GET /api/public/v1/event-schedule/:eventScheduleID
   * @param eventScheduleId - The ID of the event schedule
   * @returns Promise containing the event schedule response with booking categories
   */
  getEventSchedule: async (eventScheduleId: string): Promise<EventScheduleApiResponse> => {
    const response = await publicApiClient.get<EventScheduleApiResponse>(
      `/api/public/v1/event-schedule/${eventScheduleId}`
    );
    return response;
  },
};
